import { render, staticRenderFns } from "./ClickView.vue?vue&type=template&id=3bbda091&lang=pug&"
import script from "./ClickView.vue?vue&type=script&lang=js&"
export * from "./ClickView.vue?vue&type=script&lang=js&"
import style0 from "./ClickView.vue?vue&type=style&index=0&id=3bbda091&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports